import round from "./round";
import priceWithZeros from "./priceWithZeros";
import formatIntWithCommas from "./formatIntWithCommas";
import { AddonObj } from "./quoteCartStorage";

type BasePriceArgs = {
  itemizedCosts: AddonObj[];
  unitPrice: string;
  qty: number;
  margin?: number;
  withMarkup?: boolean;
};

function getBasePrice(basePriceArgs: BasePriceArgs) {
  const { itemizedCosts, unitPrice, qty } = basePriceArgs;

  const addonsTotal = itemizedCosts.reduce(
    (previousValue, currentValue) => previousValue + currentValue.price,
    0
  );

  const totalUnitPrice = Number(unitPrice.replace(",", ""));

  var basePrice = round(totalUnitPrice / qty - addonsTotal);

  if (basePriceArgs.margin)
    basePrice = !basePriceArgs.withMarkup
      ? round(basePrice / basePriceArgs.margin)
      : round(basePrice * (1 - basePriceArgs.margin + 1));

  return formatIntWithCommas(priceWithZeros(basePrice));
}

export default getBasePrice;
